import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class OnlineBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.online;
    }
}
export default OnlineBehavior;
